module.exports = __webpack_public_path__ + "static/media/clipboard-check.85358031.svg";